import styled, { keyframes } from 'styled-components';

// 🔁 Animación más limpia
const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

// 🎯 Spinner configurable
const Spinner = styled.div`
  width: ${({ size = 48 }) => size}px;
  height: ${({ size = 48 }) => size}px;
  border-radius: 50%;

  border: ${({ size = 48 }) => Math.max(2, size / 12)}px solid #e5e7eb;
  border-top-color: ${({ color = '#111827' }) => color};

  animation: ${rotate} 0.8s linear infinite;
`;

// 📦 Contenedor centrado
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
`;

// ✅ Componente reutilizable
export const CustomLoader = ({
  label = 'Loading...',
  size = 48,
  color = '#111827',
}) => {
  return (
    <Container>
      <Spinner size={size} color={color} />
      <span style={{ fontSize: '14px', color: '#6B7280' }}>
        {label}
      </span>
    </Container>
  );
};